<div *ngIf="!loading">

  <!-- Referrer -->
  <div class="section-referrer" *ngIf="profile">
    <div class="container-fluid" style="background: url('/images/affiliate/geometry.png');">
      <div class="row">
        <div class="col">
          <br/>
          <br/>

          <div class="text-center">
            <div>
              <img class="img-responsive img-circle" [src]="profile.user.image ? profile.user.image.filePath : '/images/affiliate/profile-default.png'" style="max-width: 200px" alt="User profile picture"/>
            </div>

            <br/>

            <h1>{{ profile.user.firstName }} is inviting you to join Croissant</h1>

            <!-- Promotion -->
            <div *ngIf="region && promotion">

              <!-- Referral -->
              <span *ngIf="promotion.code === 'FRIEND'">Plus, an extra <strong class="underline">{{ region.referralAmount / 100 | money: region.currency:2:true }} credit</strong> towards your first month of membership 🎉</span>

              <!-- Affiliate -->
              <span *ngIf="promotion.code === 'AFFILIATE'">It's the clever new way to get work done on-the-go. Sign up today for a <strong>discounted membership</strong>!</span>

            </div>

            <br/>
            <br/>

            <a class="btn btn-neon-blue" routerLink="/join">Get my Croissant membership</a>

            <br/>
            <br/>
          </div>

          <br/>
          <br/>
        </div>
      </div>
    </div>
  </div>

  <!-- How it works -->
  <div class="section-how-it-works">
    <br/>
    <br/>
    <br/>

    <div class="container">
      <div class="row">
        <div class="col text-center">
          <h2>How it works</h2>
          <p>Croissant is the app that lets you access coworking spaces on demand.</p>
          <br/>
          <br/>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-4">
          <div class="row">
            <div class="col-auto"><picture>
              <source srcset="/images/affiliate/globe.webp" type="image/webp">
              <img src="/images/affiliate/globe.png" style="max-width: 80px" alt="Globe icon">
            </picture></div>
            <div class="col">Search for a coworking space nearby. See real-time availability worldwide!</div>
          </div>
          <br/>
          <br/>
        </div>
        <div class="col-12 col-md-4">
          <div class="row">
            <div class="col-auto"><picture>
              <source srcset="/images/affiliate/phone.webp" type="image/webp">
              <img src="/images/affiliate/phone.png" style="max-width: 80px" alt="Phone icon">
            </picture></div>
            <div class="col">Check in with the Croissant app when you arrive at the coworking space.</div>
          </div>
          <br/>
          <br/>
        </div>
        <div class="col-12 col-md-4">
          <div class="row">
            <div class="col-auto"><picture>
              <source srcset="/images/affiliate/computer.webp" type="image/webp">
              <img src="/images/affiliate/computer.png" style="max-width: 80px" alt="Computer icon">
            </picture></div>
            <div class="col">Connect to wifi, grab a coffee, and do your thing. Don't forget to check out.</div>
          </div>
          <br/>
          <br/>
        </div>
      </div>
    </div>

    <br/>
    <br/>
    <br/>
  </div>

  <!-- Places -->
  <div class="section-places" *ngIf="places.length > 0">
    <br/>
    <br/>
    <br/>

    <div class="container">
      <div class="row">
        <div class="col text-center">
          <h2>Meet, work, & focus at these spaces</h2>
          <p>Hop into one of these inspiring coworking spaces with your coworking passport.</p>
          <br/>
          <br/>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-xxl-10 offset-xxl-1">
          <div class="row">
            <div class="col-6 col-md-4" *ngFor="let place of places">
              <div class="place-panel">
                <img class="img-responsive" [src]="place.smallImages.length > 0 ? place.smallImages[0].filePath : '/images/affiliate/place-default.png'" [alt]="place.name"/>
                <div class="place-detail-panel">
                  <h3 class="place-detail-title">{{ place.name }}</h3>
                  <small class="place-detail-neighborhood">{{ place.location!.neighborhood }}</small>
                </div>
              </div>
              <br/>
            </div>
          </div>
        </div>
      </div>
    </div>

    <br/>
    <br/>
    <br/>
  </div>

  <!-- Mobile -->
  <div class="section-mobile" style="background: url('/images/affiliate/geometry.png');">
    <br/>
    <br/>
    <br/>

    <div class="container">
      <div class="row">
        <div class="col-12 col-lg-10 offset-lg-1 col-xxl-8 offset-xxl-2">
          <div class="row justify-content-center">
            <div class="col-auto order-1 order-md-0 ps-5 pe-5">
              <picture>
                <source srcset="/images/affiliate/mobile.webp" type="image/webp">
                <img src="/images/affiliate/mobile.png" class="img-responsive" style="max-width: 280px" alt="Mobile app screenshot">
              </picture>
            </div>
            <div class="col text-start order-0 order-md-1">
              <br/>
              <br/>
              <h1>Start your membership today</h1>

              <br/>

              <p>Join our community of remote workers, freelancers, entrepreneurs, and creatives. Once you start your membership, the entire Croissant network is at your fingertips.</p>

              <br/>

              <a class="btn btn-neon-blue" routerLink="/join">Get my Croissant membership</a>

              <br/>
              <br/>
              <br/>
              <br/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>

<!-- Loading -->
<div class="text-center" *ngIf="loading">
  <br/>
  <br/>
  <span class="spinner-border"></span>
  <br/>
  <br/>
</div>
